//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    name: "SetStatus",
    components: { AQInput },
    props: {
        type: String,
        value: {
            type: Object
        },
        readonly: {
            type: Boolean
        }
    },
    data() {
        return {
            localStatusName: "",
            localStatusCode: "",
            duplicatedCode: false,
            prefixLabel: ""
        };
    },
    computed: {
        ...mapGetters("diagrams", ["diagramConfigData", "diagramData", "lastPluginCreated"]),
        errorLabel() {
            if (this.duplicatedCode) {
                return this.$t("diagrams.duplicatedCode", { name: this.localStatusCode });
            }
        },
        computedStatusName: {
            get() {
                return this.localStatusName || (this.value ? (this.value.statusName || "") : "");
            },
            set(v) {
                if (!v && !this.computedStatusCode) {
                    return false;
                }

                this.localStatusName = v;

                this.$emit("input", { statusName: v, statusCode: this.computedStatusCode });
            }
        },
        computedStatusCode: {
            get() {
                if (this.localStatusCode || (this.value && this.value.statusCode)) {
                    return this.localStatusCode || (this.value ? (this.value.statusCode || "") : "");
                }
                this.localStatusCode = "";
                let label = "";
                const label_id = this.lastPluginCreated && this.lastPluginCreated.payload ? this.lastPluginCreated.payload.PLUGIN_ID : "";

                label_id === "GENERAL_START_PLUGIN" ? this.prefixLabel = "GS_" : "";
                label_id === "GENERAL_START_PLUGIN" ? label = "Start" : "";

                const duplicates = this.diagramData.content.filter(
                    el => el.label.value === label || el.label.value.substring(0, label.length) === label
                );
                if (duplicates.length) {
                    if (duplicates.filter(
                        el => el.label.value === `${label} ${duplicates.length}`
                    ).length
                    ) {
                        this.localStatusCode += this.prefixLabel + (duplicates.length + 1);
                    } else {
                        const allFilteredActivity = this.diagramConfigData.content.filter(elem => {
                            let code = "";
                            if (elem.status && elem.status.statusCode) {
                                code = elem.status.statusCode;
                            } else if (elem.code) {
                                code = elem.code;
                            }
                            return elem.pluginType === label_id && code;
                        });
                        if (allFilteredActivity && allFilteredActivity.length) {
                            const lastElemCode = allFilteredActivity[allFilteredActivity.length - 1];
                            const dataElemCode = lastElemCode.status && lastElemCode.status.statusCode ? lastElemCode.status.statusCode : lastElemCode.code;
                            const duplicatedNumberCode = dataElemCode.split("_");
                            this.localStatusCode = this.prefixLabel + (parseInt(duplicatedNumberCode[duplicatedNumberCode.length - 1]) + 1);
                        } else {
                            this.localStatusCode += this.prefixLabel + duplicates.length;
                        }
                    }
                }
                this.computedStatusCode = this.localStatusCode;
                return this.localStatusCode;
            },
            set(v) {
                let found = false;
                if (!v && !this.computedStatusName) {
                    return false;
                }
                this.localStatusCode = v;
                const diagramData = this.diagramConfigData.content;
                for (let i = 0; i < diagramData.length; i++) {
                    if (diagramData[i].status && diagramData[i].status.statusCode) {
                        if (this.lastPluginCreated && this.lastPluginCreated.payload && diagramData[i].status.statusCode === v && diagramData[i].uuid !== this.lastPluginCreated.payload.PLUGIN_UUID) {
                            this.duplicatedCode = true;
                            this.$root.$emit("disableSaveButton", true);
                            found = true;
                            break;
                        }
                    } else if (diagramData[i].code) {
                        if (this.lastPluginCreated && this.lastPluginCreated.payload && diagramData[i].code === v && diagramData[i].uuid !== this.lastPluginCreated.payload.PLUGIN_UUID) {
                            this.duplicatedCode = true;
                            this.$root.$emit("disableSaveButton", true);
                            found = true;
                            break;
                        }
                    }
                }
                if (!found) {
                    this.duplicatedCode = false;
                    this.$root.$emit("disableSaveButton", false);
                    this.$emit("input", { statusName: this.computedStatusName, statusCode: v });
                }
            }
        }
    },
    methods: {

    }
};
